import React, { useEffect } from "react";

import { useDispatch } from "react-redux";

import { setQueuedScanLabelNames } from "actions/queuedScanLabels";

import { ModalTypes } from "constants/navigation";

import ScanningScreenView from "containers/Scans";

import { closeAllHashModals, returnToLocation } from "lib/navigation";

const ScanningModalAdapter = props => {
  const { hash } = props;
  const hashParams = hash[ModalTypes.Scan] || null;
  const {
    consignmentId,
    saleLotId,
    penArchetypeId,
    penId,
    scanLotId,
    resume,
    mode,
    penType,
  } = JSON.parse(hashParams);
  const { returnTo } = hash;
  const decodedReturnTo = returnTo ? atob(returnTo) : "";

  const dispatch = useDispatch();

  // Queued scan labels only matter for the current scanning session.
  // Forget them on any exit path - Close button, browser back, or
  // navigating away.
  useEffect(() => {
    return () => {
      dispatch(setQueuedScanLabelNames([]));
    };
  }, [dispatch]);

  const closeSelf = () => {
    if (decodedReturnTo) {
      returnToLocation(decodedReturnTo);
    } else {
      closeAllHashModals();
    }
  };

  return (
    <ScanningScreenView
      closeSelf={closeSelf}
      consignmentId={consignmentId}
      mode={mode}
      resume={resume}
      saleLotId={saleLotId}
      penArchetypeId={penArchetypeId}
      penId={penId}
      scanLotId={scanLotId}
      penType={penType}
    />
  );
};

export default ScanningModalAdapter;
